import { ClientType, selectUser, useStoreClient } from "@usher/pe-client-front-end-lib"
import { FormattedMessage, useIntl } from "react-intl"
import { useParams } from "react-router-dom"
import { CorporateSteps } from "./steps/Corporate"
import { CorporateInfo } from "./steps/CorporateInfo"
import { PersonalSteps } from "./steps/Personal"
import { PersonalInfo } from "./steps/PersonalInfo"
import { VerificationText } from "./VerificationText"

export const VerificationSteps = () => {
  const intl = useIntl()
  const { first_name, last_name, company_name, verify_flags, client_type } = useStoreClient(selectUser)
  const isCorporateAccount = client_type === ClientType.Coroporate
  const name = isCorporateAccount ? company_name : `${first_name} ${last_name}`
  const { type } = useParams<{ type: string }>()
  const isCardPage = type === "card"
  return (
    <>
      <VerificationText
        title={`${intl.formatMessage({
          id: "pa_149",
        })}, ${name}`}
      >
        <FormattedMessage id="pa_150" values={{ company: process.env.REACT_APP_COMPANY_NAME }} />
      </VerificationText>
      <div className="welcome-info d-flex">
        <div className="welcome-info__registration box box-dark-blue">
          <h4 className="h4 welcome-info__title text-left">
            <FormattedMessage id="pa_159" />
          </h4>
          <p className="welcome-info__descr">
            <FormattedMessage id="pa_160" />
          </p>
          <ul className="welcome-info__controls list">
            {isCorporateAccount ? (
              <CorporateSteps type={type} verify_flags={verify_flags} />
            ) : (
              <PersonalSteps type={type} verify_flags={verify_flags} />
            )}
          </ul>
        </div>
        <div className="welcome-info__verefy box-light">{isCorporateAccount ? <CorporateInfo /> : <PersonalInfo isCardPage={isCardPage} />}</div>
      </div>
    </>
  )
}
